import { render, staticRenderFns } from "./DragView.vue?vue&type=template&id=806eb0f2&scoped=true&"
import script from "./DragView.vue?vue&type=script&lang=js&"
export * from "./DragView.vue?vue&type=script&lang=js&"
import style0 from "./DragView.vue?vue&type=style&index=0&id=806eb0f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806eb0f2",
  null
  
)

export default component.exports